import { RouteConfig, Route } from 'vue-router';
import Layout from '@/layout/index.vue';
import { AppRoleType } from '@/utils/permission';

const accountRoutes: RouteConfig = {
  path: '/account',
  component: Layout,
  redirect: '/account/list',
  meta: {
    title: 'Account',
    icon: 'mdi-account',
    alwaysShow: true,
    roles: [AppRoleType.ADMIN, AppRoleType.GROUP_ADMIN],
  },
  children: [
    {
      path: 'list',
      component: () =>
        import(
          /* webpackChunkName: "account" */ '@/views/account/list/index.vue'
        ),
      name: 'account-list',
      meta: {
        title: 'Account list',
        icon: 'mdi-account-multiple',
        roles: [AppRoleType.ADMIN, AppRoleType.GROUP_ADMIN],
      },
    },
    {
      path: 'create',
      component: () =>
        import(
          /* webpackChunkName: "account" */ '@/views/account/create/index.vue'
        ),
      name: 'account-create',
      meta: {
        title: 'Account create',
        icon: 'mdi-account-plus',
        roles: [AppRoleType.ADMIN, AppRoleType.GROUP_ADMIN],
      },
    },
    {
      path: ':id',
      component: () =>
        import(
          /* webpackChunkName: "account" */ '@/views/account/detail/index.vue'
        ),
      name: 'account-detail',
      meta: {
        title: 'Account detail',
        icon: 'mdi-account-card-details',
        hidden: true,
        roles: [AppRoleType.ADMIN, AppRoleType.GROUP_ADMIN],
      },
      props: route => ({
        id: route.params.id,
      }),
    },
  ],
};

export default accountRoutes;
